<div class="modal-body width-700">
  <div class="layout-auto-auto-1-auto">
    <div class="grid-auto-1-auto">
      <h4 class="modal-header">{{getRessource('Kommentare')}}&nbsp;</h4>
      <div class="app-width-available"></div>
      <div class="grid-auto-1-auto app-width-fit-content typo-center">
        <div class="app-space-right">
	        <img class="app-user_avatar__smaller" [src]='appData.userData?.idProfilePicture || appData.defaultProfilePicture'
               alt="profilpic" (click)="close();appData.showSettings()"
          />
        </div>
        <div class="typo-small app-space-right app-space-left">
          {{excSecurity.UserName}}
        </div>
        <div class="app-space-left">
          <i class="fal fa-ellipsis-v">
          </i>
        </div>
      </div>
    </div>
    <div class="app-nospace">
        <div class="grid-auto-1-auto-start">
          <i (click)="setDefault()"
             class="search-filter-action far fa-times app-space-right app-space-top_1p5"
             [class.disabled]="!VCValueText.value"
             [tooltip]="getGlobal('Cancel')">
          </i>
          <app-textarea-input
            #VCValueText
            [maxCLength]="5000"
            [value]="newComment"
            [caption]="getRessource('comment')">
          </app-textarea-input>
          <button (click)="send()" [disabled]="!VCValueText.value"
                  class="md-btn typo-small app-space-right app-space-top_1p5">
            {{getGlobal('Create')}}
          </button>
        </div>
    </div>
    <div class="content height-400 search-filter-seperator">
      <app-commentary-box #VCContentBox [hidden]="!data.checkview"
                          [checkview]="data.checkview">
      </app-commentary-box>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Close')}}
      </button>
    </div>
  </div>
</div>
